/*
INTELLECTUAL PROPERTY NOTICE
© Orbit Tickets Ltd. All rights reserved.
This file contains Custom / Included Intellectual Property created for and owned by the Customer as part of an application developed by Kaleida within the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, the inclusion of any application within the Platform does not restrict the Customer's right to use Custom / Included Intellectual Property outside of the Platform.
*/

// IP-NOTICE: CUSTOM
import { IIconActionButton } from 'app/shared/interfaces/IIconActionButton.interface';
import { ActionableItemState } from 'app/shared/models/actionable-item-state';
import { BookingConfirmationDesignListItemModel } from './booking-confirmation-design-list-item.model';

export class BookingConfirmationDesignListItemViewModel extends ActionableItemState {
  activateToggleButton: IIconActionButton;
  deleteItemButton: IIconActionButton;

  constructor(dataModel: BookingConfirmationDesignListItemModel) {
    super();

    this.dataModel = dataModel;
    const activateToggleIcon = dataModel.isActive === true ? 'block' : 'check';
    const activateToggleDescription = dataModel.isActive === true ? 'Deactivate' : 'Activate';

    this.activateToggleButton = {
      visible: true,
      enabled: true,
      actionEnabled: true,
      actionDisabledMessage: '',
      iconName: activateToggleIcon,
      actionName: 'activateToggle',
      hoverText: activateToggleDescription,
      class: '',
      buttonText: '',
      popover: '',
    };

    this.deleteItemButton = {
      visible: true,
      enabled: true,
      actionEnabled: dataModel.canDelete,
      actionDisabledMessage: dataModel.cannotDeleteReason,
      iconName: 'delete',
      actionName: 'deleteItem',
      hoverText: 'Delete',
      class: '',
      buttonText: '',
      popover: '',
    };

    this.processActions.push(this.activateToggleButton);
    this.processActions.push(this.deleteItemButton);
  }
}
